import React, { useEffect, useState, useRef } from "react";
import { Switch, Route } from "react-router-dom";
import { useSelector } from 'react-redux';
import LoginPage from "../views/LoginPage";
import {
    Container,
    Header,
    Content,
    Navbar,
} from 'rsuite';
import { Icon } from '@rsuite/icons';
import { MainLogo } from "../utils/icons";
import image from "assets/img/full-screen-image-2.jpg";
require('assets/css/authLayout.css');

function Auth() {
    const site = useSelector(state => state.site);
    const [iconLogo, setIconLogo] = useState(null);

    const getRoutes = (routes) => {
        return routes.map((prop, key) => {
            if (prop.collapse)
                return getRoutes(prop.views);
            if (prop.layout === "/auth")
                return (<Route path={prop.layout + prop.path} key={key} component={prop.component} />);
            return null;
        });
    };

    useEffect(() => {
        if (site.site) {
            console.log(MainLogo);
            fetch(site.site.apiServer + '/catalogo/res/logo')
                .then((r) => r.text())
                .then((r) => setIconLogo(r));
        }
    }, [site]);

    return (
        <div className="wrapper wrapper-full-page">
            <div className="full-page section-image" data-color="black">
                <Container>
                    
                    <Content style={{ padding: "20px" }}>
                        <Switch>{
                            getRoutes([
                                {
                                    path: "/login-page",
                                    layout: "/auth",
                                    name: "Login Page",
                                    mini: "LP",
                                    component: LoginPage,
                                },
                            ])}</Switch>
                    </Content>
                </Container>
                <div className="full-page-background" style={{ backgroundImage: `url(${image})`}}></div>
            </div>
        </div>
    );
}
export default Auth;